import React from "react";
import {
  Edit,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  ReferenceField,
  TextField,
  useNotify,
  useRefresh,
  useRedirect,
  FormDataConsumer,
  SaveButton,
  useCreate,
  useUpdate,
  Button,
  Toolbar,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import firebaseConfig from "../../FIREBASE_CONFIG";
import { useFormState } from "react-final-form";

const TransferOrderEdit = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const handleSendNotification = async ({ data }) => {
    let requestUrl = "https://fcm.googleapis.com/fcm/send";
    const { id, status, refuseReason, refund, userId } = data;
    try {
      let notificationBody = "";
      if (status === "PENDING") {
        notificationBody = "on hold";
      } else if (status === "REFUSED") {
        notificationBody = `refused because ${refuseReason}`;
      } else if (status === "DONE") {
        notificationBody = `transferred successfuly`;
      }

      const response = await fetch(requestUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "key=" + firebaseConfig.cloudMessagingServerKey,
        },
        body: JSON.stringify({
          notification: {
            title: `Update regarding transfer order #${id}`,
            body: `Your transfer order status was updated to ${notificationBody}`,
          },
          to: "/topics/user_" + userId,
          data: {
            notificationType: "TRANSFER_ORDER_RESULT_NOTIFICATION",
            payload: {
              id,
              status,
              refuseReason,
              refund,
            },
          },
        }),
      });
      if (!response.ok) {
        console.log(response);
        return;
      }
      if (response.ok && response.status == 200) {
        const responseJSON = await response.json();
        notify(`Changes saved`);
        // redirect("/transferOrders");
        // refresh();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Edit
      title={`Edit Transfer Order`}
      onSuccess={handleSendNotification}
      mutationMode="pessimistic"
      {...props}
    >
      <SimpleForm style={{ width: "100%" }}>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              User:{" "}
              <ReferenceField
                label="User"
                source="userId"
                reference="users"
                fullWidth
              >
                <>
                  <TextField source="firstName" />{" "}
                  <TextField source="lastName" />
                </>
              </ReferenceField>
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={4}>
              Wallet Account: <TextField source="walletAccount" />
            </Grid>
          </Grid>
        </div>

        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={4}>
              Ama Coins to transfer: <TextField source="amaCoinsToTransfer" />
            </Grid>
          </Grid>
        </div>

        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={4}>
              Order Date: <TextField source="createdAt" />
            </Grid>
          </Grid>
        </div>

        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={4}>
              <SelectInput
                source="status"
                optionText="name"
                optionValue="id"
                choices={[
                  { id: "PENDING", name: "Processing" },
                  { id: "DONE", name: "Done" },
                  { id: "REFUSED", name: "Refused" },
                ]}
              />
            </Grid>
          </Grid>
        </div>
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.status === "REFUSED" && (
              <>
                <div style={{ width: "100%" }}>
                  <TextInput
                    label="Refuse Reason"
                    source="refuseReason"
                    isRequired
                    validate={required()}
                    multiline
                    fullWidth
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <SelectInput
                    source="refund"
                    optionText="name"
                    optionValue="id"
                    defaultValue="REFUND"
                    choices={[
                      { id: "REFUND", name: "Give Refund" },
                      { id: "NO_REFUND", name: "Dont Refund" },
                    ]}
                  />
                </div>
              </>
            )
          }
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};

export default TransferOrderEdit;
